module.exports = __webpack_public_path__ + "static/proweek-flyer22-f3d8241636190f41184ea3fd87079dcf.jpeg";